import { Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IRequestCallback } from '@df/api/request/request.service';
import { Basket } from '@df/basket/basket.interfaces';
import { CouponFormComponentDef } from '@df/basket/coupon-form.component.def';
import { TimeoutService } from '@df/ng/timeout.service';
import { NOTICES } from '@df/ui/api/notice/notice.const';
import { GridColumnDirective } from '@df/ui/atomic/atom/grid/grid-column.directive';
import { GridDirective } from '@df/ui/atomic/atom/grid/grid.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ButtonStyleComponent } from '../../../common/buttons/button-style/button-style.component';
import { FormMuiFieldComponent } from '../../../common/form/mui-field/form-mui-field.component';
import { ResultComponent } from '../../../common/result/result.component';
import { BasketViewExpandableComponent } from '../../expandable/basket-view-expandable.component';

NOTICES['INVALID_GIFTCARD'] = 'Code is invalid - please enter a valid code';

@Component({
    selector: 'basket-view-coupon-form',
    styleUrl: './basket-view-coupon-form.scss',
    templateUrl: 'basket-view-coupon-form.html',
    standalone: true,
    imports: [
        FormsModule,
        ButtonStyleComponent,
        ResultComponent,
        BasketViewExpandableComponent,
        GridDirective,
        GridColumnDirective,
        FormMuiFieldComponent,
        TranslationModule
    ]
})
export class BasketViewCouponFormComponent extends CouponFormComponentDef {
    forceError = false;

    @ViewChild(BasketViewExpandableComponent)
    basketViewExpandableComponent?: BasketViewExpandableComponent;

    private timeoutService = inject(TimeoutService);

    get coupons(): string[] {
        this.isCheckout;
        const coupon = this.coupon || [];
        return Array.isArray(coupon) ? coupon : [coupon];
    }

    cancel(): void {
        this.basketViewExpandableComponent?.toggle(false);
    }

    onClose(): void {
        this.timeoutService.setTimeout(() => {
            if (this.form) {
                this.form.submitAttempt = false;
                this.form.ngSubmit.emit();
                this.forceError = false;
                this.data.coupon = '';
                this.detectChanges();
            }
        }, 500);
    }

    onInputChange(): void {
        this.forceError = false;
        this.detectChanges();
    }

    protected override onSubmitError(data: Basket.ICouponFormData, response?: any): void {
        super.onSubmitError(data, response);
        this.forceError = true;
        this.detectChanges();
    }

    override submit(onSuccess: IRequestCallback = [], onError: IRequestCallback = []): void {
        if (this.form?.valid) {
            this.forceError = false;
            this.detectChanges();
        }
        super.submit(onSuccess, onError);
    }

    protected override getSubmitAction() {
        const data = { ...this.data, checkout: this.isCheckout };
        if (this.isCheckout) {
            return () => {
                return this.app.request.send(undefined, { path: 'checkout/couponAdd', data });
            };
        } else {
            return () => this.app.customer.basket.addCoupon(undefined, data);
        }
    }

    override remove(code: string | string[] | undefined = this.coupon) {
        if (!this.coupon) {
            return;
        }
        const path = this.isCheckout ? 'checkout/couponRemove' : 'coupon/remove';
        return this.app.request.send(this.removeStatus, { path, data: { coupon: code, checkout: this.isCheckout } });
    }
}
